import { useCallback } from 'react';

import { intercom, INTERCOM_EVENTS } from '../../../../../services/intercom';
import { PlanDetailsMap } from '../../plan-details-map';

export const PlanOverviewMap = () => {
  const contextualMenuOpen = useCallback(() => {
    intercom.track(INTERCOM_EVENTS.plan.overview.map.contextual_clicked);
  }, []);

  return (
    <div style={{ backgroundColor: `white`, width: `calc(100% - 380px)`, height: `calc(100vh - 64px)` }}>
      <PlanDetailsMap contextualMenuOpen={contextualMenuOpen} />
    </div>
  );
};
